import { version as ckeditorVersion } from 'ckeditor5'
import { useEffect, useState } from 'react'

const CKEDITOR_CSS_ID = 'ckeditor-styles'
const CKEDITOR_CSS_URL = `https://cdn.ckeditor.com/ckeditor5/${ckeditorVersion}/ckeditor5.css`

const PREMIUM_FEATURE_CSS_ID = 'ckeditor-premium-styles'
const CKEDITOR_CSS_PREMIUM_FEATURE_URL = `https://cdn.ckeditor.com/ckeditor5-premium-features/${ckeditorVersion}/ckeditor5-premium-features.css`

export const useCKEditorCss = () => {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (document.getElementById(CKEDITOR_CSS_ID)) {
      setIsLoading(false)
      return
    }

    const link = document.createElement('link')
    link.id = CKEDITOR_CSS_ID
    link.href = CKEDITOR_CSS_URL
    link.rel = 'stylesheet'

    const premiumFeatureLink = document.createElement('link')
    premiumFeatureLink.id = PREMIUM_FEATURE_CSS_ID
    premiumFeatureLink.href = CKEDITOR_CSS_PREMIUM_FEATURE_URL
    premiumFeatureLink.rel = 'stylesheet'

    link.onload = () => {
      setIsLoading(false)
    }

    link.onerror = () => {
      setIsLoading(false)
    }

    document.head.appendChild(link)
    document.head.appendChild(premiumFeatureLink)
  }, [])

  return { isLoading }
}
